import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ContextProviderWrapper } from '../../app/contextProviderWrapper';
import { RecoverLoginPageContents } from './recoverLoginPageContents';
export const RecoverLoginPage = () => {
    return (_jsx(ContextProviderWrapper, { instanceId: 0, numInstances: 1, children: _jsx(RecoverLoginPageContents, {}) }));
};
